import { StockCountSource } from "@towersystems/roam-common/lib/generated-types";
import { StartStockCountFormValues } from "./types";
import * as Yup from "yup";

export const defaultFormValues: StartStockCountFormValues = {
  name: "",
  source: StockCountSource.INTERNAL,
  locationId: "",
};

export const schema = Yup.object().shape({
  name: Yup.string().required("Please enter a name"),
  source: Yup.string().required("Please select a source"),
  locationId: Yup.string().required("Please select a location"),
});
